import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import logoColor from "../../assets/galaxy-labs-logo.png"
import { toast } from 'react-toastify';
import { useForgotVerificationPostMutation } from "../../Services/ForgotPasswordApi"
import loginIcon from "../../assets/rrrr.png";

const OtpVerification = () => {
   const navigate = useNavigate();
   const [addVerificationCode] = useForgotVerificationPostMutation();
   const [verifyCode, setVerifyCode] = useState('');

   const verifyHandler = (e) => {
      e.preventDefault();
      navigate('/reset-password')
      // if (verifyCode.length !== 4) {
      //    return toast.error("Verification code should be 4 digits")
      // } 
      // let user = localStorage.getItem('emailAdmin');
      // let verificationDetail = {
      //    email: user,
      //    otp: verifyCode
      //  }
      //  addVerificationCode(verificationDetail)
      //    .unwrap()
      //    .then((res) => {
      //      toast.success(res?.message);
      //      if (res?.success) {
      //       navigate('/reset-password')
      //      }
      //    })
      //    .catch((err) => {
      //      toast.error(err?.data?.message);
      //    });

   }
   return (



      <div className="container">
         <div className="row justify-content-center align-items-center min-vh-100 h-100">
            <div className="col-md-5">
               <div className="">
                  <img src={logoColor} alt="logo" className="img-fluid mb-4 d-block" width="120" />
                  <h3 className="text-uppercase fw-bolder mb-3 pt-4 text-color">Verfication Code</h3>
                  <p className="mb-4 small">We’ll send you a verification code.</p>
               </div>
               <form action="" className="form-login">
                  <div className="mb-4">
                     {/* <label for="code" className="form-label small fw-semibold text-black">Code</label> */}

                     <div className="d-flex align-items-center gap-3">
                        <input type="number"
                           className="form-control text-center"
                           placeholder="*"
                           aria-label="code" aria-describedby="code"
                           value={verifyCode}
                           onChange={(e) => {
                              const code = e.target.value;
                              // Ensure the code consists of only digits and has a length of 4
                              if (/^\d{0,4}$/.test(code)) {
                                 setVerifyCode(code);
                              }
                           }}
                           maxLength={1}
                        />

                        <input type="number"
                           className="form-control text-center"
                           placeholder="*"
                           aria-label="code" aria-describedby="code"
                           value={verifyCode}
                           onChange={(e) => {
                              const code = e.target.value;
                              // Ensure the code consists of only digits and has a length of 4
                              if (/^\d{0,4}$/.test(code)) {
                                 setVerifyCode(code);
                              }
                           }}
                           maxLength={1}
                        />

                        <input type="number"
                           className="form-control text-center"
                           placeholder="*"
                           aria-label="code" aria-describedby="code"
                           value={verifyCode}
                           onChange={(e) => {
                              const code = e.target.value;
                              // Ensure the code consists of only digits and has a length of 4
                              if (/^\d{0,4}$/.test(code)) {
                                 setVerifyCode(code);
                              }
                           }}
                           maxLength={1}
                        />

                        <input type="number"
                           className="form-control text-center"
                           placeholder="*"
                           aria-label="code" aria-describedby="code"
                           value={verifyCode}
                           onChange={(e) => {
                              const code = e.target.value;
                              // Ensure the code consists of only digits and has a length of 4
                              if (/^\d{0,4}$/.test(code)) {
                                 setVerifyCode(code);
                              }
                           }}
                           maxLength={1}
                        />
                     </div>

                  </div>


                  <button
                     type="submit"
                     onClick={verifyHandler}
                     className="btn bg-button w-100 text-white py-3 mt-3">Verify</button>

               </form>
            </div>

            <div className="col-1 decrease dmobile-none"></div>

            <div className="col-md-5 dmobile-none">
               <div className="position-relative">
                  <img src={loginIcon} alt="loginIcon" className="img-fluid z-3" />
               </div>
            </div>
         </div>
      </div>



   )
}

export default OtpVerification